import { FormItem } from "./formItems/FormItem";
import "./formContent.scss";
import {
	useGetFormRecoil,
	useGetSelectedSectionIndexRecoil,
	useSetFormDetailFormRefRecoil,
} from "../formDetail.service";
import { useCallback } from "react";
import ParseHTMLContent from "../../../../components/ParseHTMLContent/ParseHTMLContent";

export const FormContent = () => {
	const { form } = useGetFormRecoil();
	const { selectedSectionIndex } = useGetSelectedSectionIndexRecoil();
	const { setFormRef } = useSetFormDetailFormRefRecoil();

	const handleFormRef = useCallback(
		(node: HTMLFormElement | null) => {
			setFormRef(node);
		},
		[setFormRef],
	);

	const currentSection = form?.sections[selectedSectionIndex];

	// Don't render content until form and section are loaded
	if (!form || !currentSection) {
		return null;
	}

	return (
		<div className="formContent">
			<h1 id="titleForHeader">
				<ParseHTMLContent htmlString={currentSection.name} />
			</h1>
			{currentSection.description && (
				<p className="formContent-description">
					<ParseHTMLContent htmlString={currentSection.description} />
				</p>
			)}
			<form className="form-items" ref={handleFormRef}>
				{currentSection.items.map((item) => (
					<FormItem
						key={item.name}
						name={item.name}
						description={item.description ?? ""}
						itemFields={item.itemFields ?? []}
					/>
				))}
			</form>
		</div>
	);
};
